import { observer } from "mobx-react-lite";
import React, { useEffect, useState, useMemo, useCallback } from "react";
import Checkbox from "@material-ui/core/Checkbox";
import { displayMoney } from "../../helpers/money.helper";
import Axios from "axios";
import { usePrevious } from "../../helpers/usePrevious";
import { Spinner } from "reactstrap";
import { Asterisk } from "../../components/Asterisk";
import { runInAction, toJS } from "mobx";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@material-ui/icons/RadioButtonChecked";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import EventLabel from "../../components/EventLabel";
import { EventDates } from "./components/EventDates";
import { EventLocation } from "./components/EventLocation";
import { toCamelCase } from "../../helpers/objectHelper";
import { getUrlParam } from "../../helpers/url.helper";
import { is } from "core-js/core/object";

export const Event = observer((props) => {
  const [isFetching, setIsFetching] = useState(false);
  const [isFullBooked, setIsFullbooked] = useState(false);
  const [isNoVouchersAvailable, setIsNoVouchersAvailable] = useState(false);
  const [isReadonly, setIsReadonly] = useState(false);
  const [isFetchingVouchers, setIsFetchingVouchers] = useState(false);

  const {
    settings,
    environment,
    breakouts,
    contentLayoutModuleId,
    displayEventSettings,
    checkConditions,
    current,
    updateOrder,
    activePersonNo,
    contentLayout,
    validations,
    contentModuleId,
    hasParent,
    updateOrderRow,
    setBreakoutFullbooked,
    checkEventAvailability,
    validate: vdate,
    parentValid,
  } = props;

  const orders = toJS(props.orders);
  const { eventId, readonly, hidden, prechecked, allowOverbooking, escape, required, overrideDisplay, displayType = "checkbox", displayYesNo = false, voucherCheck, showAlternativeName = false } = settings;
  const validity = validations.find((v) => v.id == contentModuleId);
  const prevProps = usePrevious(props);

  //const order = orders[activePersonNo];
  const order = useMemo(() => {
    return orders[activePersonNo];
  }, [props.orders, orders, activePersonNo]);
  const breakout = breakouts.find((q) => q.eventId == eventId);
  const eventRejected = useMemo(() => {
    return Boolean(order?.orderExtra?.find((oe) => oe.name === "EventRejected" && oe.value == eventId));
  }, [order, order?.orderExtra]);
  const activeDisplaySettings = useMemo(() => {
    if (overrideDisplay) {
      const o = {};
      for (const key in displayEventSettings) {
        if (Object.hasOwnProperty.call(displayEventSettings, key)) {
          o[key] = settings[toCamelCase(key)] === true;
        }
      }
      return o;
    } else {
      return displayEventSettings;
    }
  }, [
    overrideDisplay,
    displayEventSettings,
    settings?.showEventStartDateTime,
    settings?.showEventStartTime,
    settings?.showEventEndDateTime,
    settings?.showEventEndTime,
    settings?.showEventCity,
    settings?.showEventVenue,
    settings?.showEventDescription,
    settings?.showEventPrice,
    settings?.showEventName,
    settings?.showEventIncVat,
    settings?.showEventVatPrecentage,
    settings?.showEventVatSum,
  ]);

  if (!breakout) return null;

  const { name, startDateTime, endDateTime, description, amount, vatPercent, eventDisplayLanguage, deadline } = breakout;

  const displayLang = eventDisplayLanguage.find((x) => x.languageCode === environment.lang && x.alternative === showAlternativeName);

  const isDue = useMemo(() => (deadline ? +new Date(deadline) < +new Date() : false), [deadline]);

  useEffect(() => {
    if (prechecked) {
      checkAvailableStatus(true, true);
    } else {
      checkAvailableStatus();
    }
  }, []);

  useEffect(() => {
    validate();
    checkForOverbooking();
  }, [order, order?.orderRow, isFullBooked]);

  useEffect(() => {
    if (!orders?.[activePersonNo]?.badgeNo) {
      validate();
    }
  }, [orders, validate, activePersonNo]);

  useEffect(() => {
    if (prevProps && activePersonNo !== prevProps.activePersonNo && prechecked && orders?.length > 0) {
      checkAvailableStatus(true, true);
    }
  }, [activePersonNo]);

  const validate = useCallback(() => {
    let row = order?.orderRow?.find((or) => or.eventId == breakout.eventId);
    let isValid = true;
    let reason = "";

    if (isDue) {
      isValid = true;
      reason = "due";
    } else if (!isFullBooked && (readonly || hidden)) {
      isValid = true;
      return isValid;
    } else if (required && !row && !eventRejected) {
      isValid = false;
      reason = "required";
    }

    if (hasParent && typeof props.validateGroup === "function") {
      props.validateGroup({ isValid, reason });
    } else if (validity) {
      runInAction(() => {
        validity.valid = isValid;
        validity.reason = reason;
      });
    }
  }, [isFullBooked, readonly, hidden, required, isDue, eventRejected, hasParent, validity, order, breakout.eventId]);

  const checkForOverbooking = () => {
    const events = contentLayout.contentLayoutModules.filter((fe) => {
      return fe.contentModule && fe.contentModule.type === "EVENT" && fe.contentModule.settings.eventId !== breakout.eventId;
    });

    events.map((e) => {
      if (!allowOverbooking && e.pages === current.page) {
        let matchedEvent = breakouts.find((q) => q.eventId == e.contentModule.settings.eventId);
        if (matchedEvent) {
          if (
            (+new Date(matchedEvent.startDateTime) > +new Date(startDateTime) && +new Date(matchedEvent.startDateTime) < +new Date(endDateTime)) ||
            (+new Date(matchedEvent.endDateTime) > +new Date(startDateTime) && +new Date(matchedEvent.endDateTime) <= +new Date(endDateTime))
          ) {
            setIsReadonly(true);
          }
        }
      }
    });
  };

  const handleCheckboxChange = (value, preChecked) => {
    if (value === undefined) return;
    if (props.hasParent && settings.onlySelectOne) {
      props.uncheckGroupActivities(breakout.eventId);
    }

    var update = true;
    if (preChecked && order && order.orderRow && order.orderRow.filter((x) => x.eventId == breakout.eventId).length > 0) {
      update = false;
    }
    if (update) {
      updateOrderRow({
        amount: breakout.amount ?? 0,
        comment: "",
        discount: 0,
        eventId: breakout.eventId,
        orderId: -1,
        orderRowId: ((order?.orderRow?.length ?? 0) + 1) * -1,
        quantity: 1,
        status: null,
        vatPercent: breakout.vatPercent || 0,
        deleted: !value,
        groupId: props.hasParent ? props.parentId : null,
      });
    }
    checkConditions(contentLayoutModuleId);
  };

  const checkAvailableStatus = async (value, preChecked = false) => {
    if (value === false) {
      handleCheckboxChange(false);
      setIsFullbooked(false);
    } else {
      if (isFetching === false) {
        setIsFetching(true);
        const available = await checkEventAvailability(breakout.eventId, orders.length > 0 && orders[activePersonNo].orderId ? orders[activePersonNo].orderId : null, props.sqlStateNo, true);

        if (available) {
          checkVoucherAvailable(value, preChecked);
          setIsFullbooked(false);
        } else {
          setBreakoutFullbooked(breakout.eventId, true);
          setIsFullbooked(true);
        }
        setIsFetching(false);
      }
    }
  };

  const checkVoucherAvailable = (value, preChecked = false) => {
    const exhibitorId = order?.orderExtra?.find((x) => x.name == "ExhibitorInvite")?.value || getUrlParam("exi");
    if (!exhibitorId && getUrlParam("exi")) {
      exhibitorId = parseInt(getUrlParam("exi"));
    }

    const personTypes = order?.personTypes?.map((x) => x.personTypeId) ?? [];
    if (getUrlParam("pti") && (personTypes.length === 0 || !personTypes.some((x) => x == getUrlParam("pti")))) {
      personTypes.push(parseInt(getUrlParam("pti")));
    }
    if (!exhibitorId || !voucherCheck) {
      handleCheckboxChange(value);
    } else {
      if (isFetchingVouchers === false) {
        setIsFetchingVouchers(true);

        Axios.get(
          `./api/exhibitor/availableVouchers/${breakout.eventId}${orders.length > 0 && orders[activePersonNo].orderId ? "/" + orders[activePersonNo].orderId : ""}?sqlStateNo=${
            props.sqlStateNo
          }&exi=${exhibitorId}&ptis=${personTypes.join(",")}`
        )
          .then(({ data }) => {
            if (data.available) {
              handleCheckboxChange(value, preChecked);
              setIsNoVouchersAvailable(false);
            } else {
              setIsNoVouchersAvailable(true);
            }
            setIsFetchingVouchers(false);
          })
          .catch((err) => {
            setIsFetchingVouchers(false);

            console.error(err);
          });
      }
    }
  };

  const price = (asNumber = false) => {
    let discountAmount = 0;

    let discounts = order?.discounts || [];
    if (order && order.orderId > 0 && order?.orderRow?.find((o) => o.eventId == breakout.eventId)) {
      discountAmount = order?.orderRow?.find((o) => o.eventId == breakout.eventId)?.discount;
    }

    discounts
      .filter((d) => (d.targetEventId == breakout.eventId && d.value != 0) || (d.targetEventId == null && d.valueType == "Percent" && d.value != 0))
      .sort((a, b) => {
        return a.value - b.value;
      })
      .map((d) => {
        discountAmount += d.valueType == "Percent" ? (amount - discountAmount) * (d.value / 100) : d.value;
      });

    const oldPrice = parseFloat(displayEventSettings["ShowEventIncVat"] == true ? displayMoney(parseFloat(amount), vatPercent) : amount);

    const price = parseFloat(displayEventSettings["ShowEventIncVat"] ? displayMoney(parseFloat(amount - discountAmount), vatPercent) : amount - discountAmount);

    if (asNumber) {
      return discountAmount;
    }

    if (!discountAmount) return <p>{`${price} ${environment.currency}`}</p>;

    return (
      <>
        <p style={{ textDecoration: "line-through" }}>{`${oldPrice} ${environment.currency}`}</p>
        <p style={{ color: "#4caf50", marginLeft: 10 }}>{`${price > 0 ? price : 0} ${environment.currency}`}</p>
      </>
    );
  };

  const isChecked = useMemo(
    () => Boolean(orders.length >= activePersonNo + 1 && orders[activePersonNo]?.orderRow?.find((or) => or.eventId == breakout.eventId && !or.deleted)),
    [orders, activePersonNo, breakout.eventId]
  );

  const isValid = useMemo(() => {
    if (vdate && (validations.find((v) => v.id === contentModuleId)?.valid === false || parentValid === false)) return false;
    return undefined;
  }, [vdate, validations, contentModuleId]);

  const statusLabel = useMemo(() => {
    if (isFullBooked) {
      return <EventLabel name="FullBooked" groupName="CMS.FormEvent" />;
    } else if (isNoVouchersAvailable) {
      return <EventLabel name="NoVouchersAvailable" groupName="CMS.FormEvent" />;
    } else if (isDue) {
      return <EventLabel name="EventDue" groupName="CMS.FormEvent" />;
    }
    return null;
  }, [isFullBooked, isNoVouchersAvailable, isDue]);

  if (hidden) return null;

  return (
    <>
      <div className={"left-col" + (displayYesNo ? " btn-row" : "")}>
        {displayYesNo ? (
          <>
            <button onClick={() => (!isChecked && !isFetching && !isFetchingVouchers ? checkAvailableStatus(true) : null)} disabled={isFullBooked || readonly} className={`cms-button ${isChecked ? "active" : ""}`}>
              <div className="spinner-wrap">
                <EventLabel groupName="CMS.FormEvent" name="YesBtn" />
                {!isFetching && !isFetchingVouchers ? null : <Spinner className="custom-spinner" />}
              </div>
            </button>
            &nbsp;
            <button onClick={() => checkAvailableStatus(false)} disabled={readonly} className={`cms-button ${!isChecked && eventRejected ? "active" : ""}`}>
              <EventLabel groupName="CMS.FormEvent" name="NoBtn" />
            </button>
          </>
        ) : !isFetching && !isFetchingVouchers ? (
          <Checkbox
            disabled={(isFullBooked && !isChecked) || readonly || isDue}
            style={{ opacity: statusLabel ? 0.3 : 1, cursor: statusLabel ? "not-allowed" : "pointer" }}
            onChange={(e) => checkAvailableStatus(e.target.checked)}
            icon={
              props.hasParent && settings.displayType === "radio" ? (
                <RadioButtonUncheckedIcon style={{ color: isValid === false ? "#d53443" : undefined }} className="checkbox cms-checkbox" />
              ) : (
                <CheckBoxOutlineBlankIcon className="checkbox cms-checkbox" style={{ color: isValid === false ? "#d53443" : undefined }} />
              )
            }
            checkedIcon={props.hasParent && settings.displayType === "radio" ? <RadioButtonCheckedIcon className="checkbox cms-checkbox" /> : <CheckBoxIcon className="checkbox cms-checkbox" />}
            checked={isChecked}
            className="checkbox"
            name="checkedA"
          />
        ) : (
          <Spinner className="custom-spinner" />
        )}
      </div>

      <div className="center-col">
        {statusLabel && <p className="fully-booked">{statusLabel}</p>}
        <div style={{ opacity: statusLabel ? 0.3 : 1 }}>
          {activeDisplaySettings["ShowEventName"] && (
            <p className="eventname">
              {displayLang?.name ? displayLang.name : name}
              {required ? <Asterisk /> : null}
            </p>
          )}

          <div className="sub-col">
            <EventDates displayEventSettings={activeDisplaySettings} event={breakout} lang={environment.lang} />
            <EventLocation displayEventSettings={activeDisplaySettings} event={breakout} />
          </div>

          {activeDisplaySettings["ShowEventDescription"] ? <p className="description">{displayLang?.description ? displayLang.description : description}</p> : null}
        </div>
      </div>
      <div className="right-col price" style={{ opacity: statusLabel ? 0.3 : 1 }}>
        {activeDisplaySettings["ShowEventPrice"] ? price() : null}
        {activeDisplaySettings["ShowEventVatSum"] ? (
          <p>
            <EventLabel name={"VatAmountLabel"} groupName={"CMS.FormEvent"} textOnly={true} /> {`${Math.round(vatPercent ? amount * (vatPercent / 100) : 0, 2)} ${environment.currency}`}
          </p>
        ) : null}
        {activeDisplaySettings["ShowEventVatPrecentage"] ? (
          <p>
            <EventLabel name={"VatPercentLabel"} groupName={"CMS.FormEvent"} textOnly={true} /> {`${vatPercent || 0}%`}
          </p>
        ) : null}
      </div>
    </>
  );
});
